import { Application } from "@hotwired/stimulus";
import { patchDocumentHeadAppendChildWithCspStyleNonce } from "utils/security";
import * as agGrid from "ag-grid-community";

declare const window: any;

patchDocumentHeadAppendChildWithCspStyleNonce();
agGrid.ModuleRegistry.registerModules([agGrid.AllCommunityModule]);

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;

window.Stimulus = application;

export { application };
